$(document).ready(function(){
$('.groupe_colls_slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  prevArrow: '<div class="slide-arrow-prev"><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.125 9.5C1.125 9.18934 1.37684 8.9375 1.6875 8.9375H14.9545L11.4148 5.39775C11.1951 5.17808 11.1951 4.82192 11.4148 4.60225C11.6344 4.38258 11.9906 4.38258 12.2102 4.60225L16.7102 9.10225C16.9299 9.32192 16.9299 9.67808 16.7102 9.89775L12.2102 14.3977C11.9906 14.6174 11.6344 14.6174 11.4148 14.3977C11.1951 14.1781 11.1951 13.8219 11.4148 13.6023L14.9545 10.0625H1.6875C1.37684 10.0625 1.125 9.81066 1.125 9.5Z" fill="currentColor"></path></svg></div>',
  nextArrow: '<div class="slide-arrow-next"><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.125 9.5C1.125 9.18934 1.37684 8.9375 1.6875 8.9375H14.9545L11.4148 5.39775C11.1951 5.17808 11.1951 4.82192 11.4148 4.60225C11.6344 4.38258 11.9906 4.38258 12.2102 4.60225L16.7102 9.10225C16.9299 9.32192 16.9299 9.67808 16.7102 9.89775L12.2102 14.3977C11.9906 14.6174 11.6344 14.6174 11.4148 14.3977C11.1951 14.1781 11.1951 13.8219 11.4148 13.6023L14.9545 10.0625H1.6875C1.37684 10.0625 1.125 9.81066 1.125 9.5Z" fill="currentColor"></path></svg></div>',
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows:false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows:false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows:false
      }
    }
  ]
}); 
}); 


// announcement bar 
